import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useGetCurrentUser } from "@/hooks/queries/useGetCurrentUser";
import { pinnedJobsQueryKey } from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import { DashboardData } from "@/types";

// Pins/unpins a job for the current user, then refetches the pinned list and
// syncs the dashboard rows' pinnedUserIds.
export function useUpdateSetPinnedJob() {
  const queryClient = useQueryClient();
  const currentUser = useGetCurrentUser();

  return useMutation({
    mutationFn: async ({
      jobId,
      pinned,
    }: {
      jobId: string;
      pinned: boolean;
    }) => {
      await guacHttpClient.patch("job-users", { jobId, pinned });
    },
    onSuccess: (_, { jobId, pinned }) => {
      void queryClient.invalidateQueries({ queryKey: pinnedJobsQueryKey });
      const userId = currentUser?.id;
      if (userId === undefined) return;
      queryClient.setQueriesData<DashboardData>(
        { queryKey: ["dashboard"] },
        (data) => {
          if (!data) return data;
          return {
            ...data,
            jobs: data.jobs.map((job) => {
              if (job.id !== jobId) return job;
              const others = job.pinnedUserIds.filter((id) => id !== userId);
              return {
                ...job,
                pinnedUserIds: pinned ? [...others, userId] : others,
              };
            }),
          };
        },
      );
    },
  });
}
